import { QuestionBase, type IQuestionBase } from './question-base';

export interface IQuestionHidden<T> extends IQuestionBase<T> {}

export class QuestionHidden<T>
  extends QuestionBase<T>
  implements IQuestionHidden<T>
{
  constructor(options: IQuestionHidden<T>) {
    super(options);
    this.elementType = 'hidden';
  }
}
